import { fetchVoucherDetails } from "../../../app/api/manageVoucher";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFetchVoucherDetailActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/VoucherActionParams";
import { IVoucherDetail } from "../../../Orchestrator/Types/Interface/IVoucherDetail";

export class FetchVoucherDetailAction extends BaseAction<IVoucherDetail, IFetchVoucherDetailActionParams> {
    override async run(): Promise<IVoucherDetail> {
        const { userId, voucherId } = this.params!
        let voucherData: IVoucherDetail = {} as IVoucherDetail;
        try {
            const response: any = await fetchVoucherDetails(userId, voucherId);
            if (response.status === "ok" && response.answer) {
                voucherData = response.answer;
                updateRecoilState("voucherDetailAtom", voucherData)
            }
        }
        catch (error) {
            console.error("Error during fetching voucher details:", error);
        }
        finally {
            return voucherData;
        }
    }
}
export const fetchVoucherDetailAction = new FetchVoucherDetailAction();
